<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-check" v-show="btnSaveVisible" @click="save">
              출고저장
            </el-button>
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelDown">엑셀</el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="요청기간" label-width="100px">
                <el-col :span="11">
                  <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                </el-col>
                <el-col :span="1" style="text-align: center;">-</el-col>
                <el-col :span="12">
                  <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="요청구분" label-width="80px">
                <el-select v-model="form.requestType" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['requestType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8" style="">
              <el-row>
                <el-form-item label="지역/센터" label-width="120px">
                  <el-col :span="8">
                    <el-select v-model="form.catId" @change="onCatIdChange">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['catId']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="16">
                    <el-select v-model="form.subCatId" v-show="changeCatIdShow">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['subCatId']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="5">
              <el-form-item label="출고구분" label-width="100px">
                <el-select v-model="form.outYn">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option value='Y' label="출고확정"></el-option>
                  <el-option value='N' label="미출고"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="제조사" label-width="70px">
                <el-select v-model="form.maker" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['maker']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8" style="margin-left:0px;">
              <el-row>
                <el-form-item label="제품군" label-width="70px">
                  <el-col :span="10">
                    <el-select v-model="form.itemGroup" @change="onModelGroupChange">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['itemGroup']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12">
                    <el-select v-model="form.subModelGroup" v-show="combos['subModelGroup']">
                      <!-- <el-option value='' label="전체">전체</el-option> -->
                      <el-option
                          v-for="item in combos['subModelGroup']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>

            <el-col :span="6">
              <el-form-item label="품번" label-width="40px">
                <el-input type="text" v-model="form.itemCd" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :context="context"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :stopEditingWhenCellsLoseFocus="true"
                :statusBar="statusBar"
                @grid-ready="onReadyMain"
                @cell-value-changed="onCellValueChanged"
                editType="fullRow"/>
          </div>

          <div class="grid-tbl-box" v-show="false">
            <ag-grid-vue
                ref="excelGrid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="excelColumnDefs"
                :grid-options="excelGridOptions"
                :row-data="excelData"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                @grid-ready="onReadyExcel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ReqMateEnterModal from '@/components/LucomsModal/ReqMateEnterModal.vue';
import AgGridSearchBtn from "@/components/agGrid/AgGridSearchBtn.vue";
import AgGridCheckbox from "@/components/agGrid/checkbox-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import mixin from "@/mixin/lucoms";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [mixin],
  props: {
  },
  data() {
    return {
      data: [],
      subData: [],
      excelData: [],
      form: {
        companyId : '',
        startDt: this.$moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        catId : '',              // 지역
        outYn : '',
        requestType : '',
        procYn : '',             // 처리상태
        maker : '',              // 제조사
        itemGroup : '',          // 제조사
        itemCd : '',             // 품번
        asAgentId : '3',         // as에서 3으로만 던지고 있음. 왜 3으로만 던지지?
        confirmYn : '',
        sortType : '',           // 승인/정산처리유형
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : '',
        memo: '',
        outCatId: '',
        outAsAgentId: '',
        outUserId:'',
        inGoodQty:0,
        subCatId: '',
        subModelGroup: ''
      },
      combos: {
        'requestType' : [],
        'catId' : [],            //지역센터
        'subCatId' : [],         //sub지역센터
        'maker' : [],            //제조사
        'itemGroup' : [],        //제품군
        'subModelGroup' : [],    //sub제품군
        'outType' : [],
        'asClass3': []           //출고센터
      },
      changeCatIdShow : false,
      btnSaveVisible : false,
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 20px; width: 100%;height: 510px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
        onKeyPress: true,
      },
      subGridApi: null,
      subColumnApi: null,
      subGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      excelGridApi: null,
      excelColumnApi: null,
      excelGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
        excelStyles: [
          { id: 'numberType',numberFormat: {format: '0',}},
          { id: 'stringType', dataType: 'String'},
          { id: 'dateType', dataType: 'DateTime'},
        ],
      },
      columnDefs: [],
      excelColumnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer,
        'schBtn' : AgGridSearchBtn,
        'checkBox' : AgGridCheckbox,
      },
      statusBar: null,
      outAsAgentNmList: [],
      outAsAgentSubNmList: [],
      outUserNmList: [],
      invtGoodQtyReList: [],
      context: {
        // context is used as a global variable
        editorUpdateMethods: {},
        editorRefs: {},
        getRefData: this.getRefData,
        getUserNmData: this.getUserNmData
      },
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;
      this.init();
      this.getCombo({flag: 'INIT'});
    },
    onReadyExcel() {
      this.excelGridApi = this.excelGridOptions.api;
      this.excelColumnApi = this.excelGridOptions.columnApi;
    },
    createMainColumnDefs() {
      let that = this;
      this.columnDefs = [];
      if (this.form.outYn === 'N') {
        this.columnDefs = [
          {
            headerName:'No',
            field:'no',
            width:80,
            cellStyle:{textAlign: 'center'},
            valueFormatter: function(params) {
              return params.node.rowIndex+1;
            }
          },
          {headerName:'요청일자', field:'requestDt', cellStyle:{textAlign: 'center'},
            cellRenderer: (params) => {
              return params.value = params.value === null  ? '' : this.$moment(params.value).format('YYYY-MM-DD HH:mm:ss');
              //this.getDateFormat(`${params.value}`) ;
            }},
          {headerName:'출고센터', field:'outCatId', width:130, cellStyle:{textAlign: 'center'},
            editable: true, cellEditingStopped: true,
            //headerClass: 'require-column' , //필수입력 컬럼 css
            cellRenderer: 'select',
            cellRendererParams: {
              options: this.outAsAgentNmList,
              detailCd: 'key',  //서버로 부터 받은 key defalut-"detailCd"
              detailNm: 'value' //서버로 부터 받은 value defalut-"detailNm"
            },
          },
          {headerName:'출고센터 상세', field:'outAsAgentId', width:120, cellStyle:{textAlign: 'center'},
            editable: true,
            cellRenderer: 'select',
            //headerClass: 'require-column' , //필수입력 컬럼 css
            cellRendererParams: {
              options: that.outAsAgentSubNmList,
              detailCd: 'key',  //서버로 부터 받은 key defalut-"detailCd"
              detailNm: 'value' //서버로 부터 받은 value defalut-"detailNm"
            },
          },
          {headerName:'출고기사', field:'outUserId', width:120, cellStyle:{textAlign: 'center'},
            editable: true,
            cellRenderer: 'select',
            //headerClass: 'require-column' , //필수입력 컬럼 css
            cellRendererParams: {
              options: that.outUserNmList,
              detailCd: 'key',  //서버로 부터 받은 key defalut-"detailCd"
              detailNm: 'value' //서버로 부터 받은 value defalut-"detailNm"
            },
          },
          {headerName:'요청센터', field:'requestAsAgentNm', width:110},
          {headerName:'요청자', field:'requestUserNm', width:110, cellStyle:{textAlign: 'center'}},
          {headerName:'요청구분', field:'requestType', cellStyle:{textAlign: 'center'}, width:110},
          {headerName:'요청품번', field:'itemCd', width:150},
          {headerName:'요청품명', field:'itemNm', width:150},
          {headerName:'요청수량', field:'goodQty', width:110, cellStyle:{textAlign: 'right'},
            valueFormatter: (params) => {
              return that.chkNumber(params, '', '');
            }
          },
          {headerName:'현재고', field:'currentInventory', width:100, cellStyle:{textAlign: 'right'},
            valueFormatter: (params) => {
              return that.chkNumber(params, '', '');
            },
            valueGetter: (params) => {
              if (this.invtGoodQtyReList[params.node.rowIndex] != null) {
                return this.invtGoodQtyReList[params.node.rowIndex]
              }
              else {
                return params.data.outDt === null ? params.data.invtGoodQty : ''
              }
            },
          },
          {headerName:'출고품번', field:'realItemCd', width:170,
            cellStyle:(params) => {
              if(this.form.outYn === 'N'){
                return {backgroundColor: '#fff8f7'}
              }
            },
            cellRenderer: 'schBtn',
            cellRendererParams:{
              funcNm : 'updateRealItem',
            }
          },
          {headerName:'출고품명', field:'realItemNm', width:180},
          {headerName:'출고수량', field:'inGoodQty', width:110,
            cellStyle:(params) => {
              if(params.data.currentInventory > 0){
                return {textAlign: 'right', backgroundColor: '#fff8f7'}
              }else{
                return {textAlign: 'right'}
              }
            },
            valueFormatter: (params) => {
              //that.cellEditingQty(params);
              // if(parseInt() > 0) {
              //   params.data.chk = 'Y';
              // } else {
              //   params.data.chk = 'N';
              // }
              return that.chkNumber(params, '', '');
            },
            editable: (params) => {
              if(params.data.currentInventory > 0){
                return true
              }else{
                return false
              }
            }
          },
          {headerName:'출고일자', field:'outDt', width:110, cellStyle:{textAlign: 'center'},
            cellRenderer: (params) => {
              return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
            }
          },
          {headerName:'메모', field:'memo', width:150, cellStyle:{textAlign: 'center'}},
          {
            headerName: '선택',
            field: 'chk',
            width: 80,
            cellRenderer: 'checkBox',
            cellRendererParams: (params) => {
              return {trueValue:  'Y', falseValue: 'N', disable: (this.form.outYn === 'Y') || (this.form.outYn == '') }
            },
          },
        ];
      }
      else {
        this.columnDefs = [
          {
            headerName:'No',
            field:'no',
            width:80,
            cellStyle:{textAlign: 'center'},
            valueFormatter: function(params) {
              return params.node.rowIndex+1;
            }
          },
          {headerName:'요청일자', field:'requestDt', cellStyle:{textAlign: 'center'},
            cellRenderer: (params) => {
              return params.value = params.value === null  ? '' : this.$moment(params.value).format('YYYY-MM-DD HH:mm:ss');
            }},
          {headerName:'출고센터 상세', field:'outRequestAsAgentNm', width:120, cellStyle:{textAlign: 'center'},
            valueFormatter: (params) => {
              return params.data.outRequestAsAgentId === null ? '대우루컴즈' : params.data.outRequestAsAgentNm;
            }
          },
          {headerName:'출고기사', field:'outRequestUserNm', width:120, cellStyle:{textAlign: 'center'},
            valueFormatter: (params) => {
              return params.data.outRequestUserId === null ? '전체' : params.data.outRequestUserNm;
            }
          },
          {headerName:'요청센터', field:'requestAsAgentNm', width:110},
          {headerName:'요청자', field:'requestUserNm', width:110, cellStyle:{textAlign: 'center'}},
          {headerName:'요청구분', field:'requestType', cellStyle:{textAlign: 'center'}, width:110},
          {headerName:'요청품번', field:'itemCd', width:150},
          {headerName:'요청품명', field:'itemNm', width:150},
          {headerName:'요청수량', field:'goodQty', width:110, cellStyle:{textAlign: 'right'}},
          {headerName:'현재고', field:'invtGoodQty', width:100, cellStyle:{textAlign: 'right'}},
          {headerName:'출고품번', field:'realItemCd', width:150},
          {headerName:'출고품명', field:'realItemNm', width:180},
          {headerName:'출고수량', field:'inGoodQty', width:110, cellStyle:{textAlign: 'right'}},
          {headerName:'출고일자', field:'outDt', width:110, cellStyle:{textAlign: 'center'},
            cellRenderer: (params) => {
              return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
            }},
          {headerName:'메모', field:'memo', width:150, cellStyle:{textAlign: 'left'}}
        ];
      }

    },
    createExcelColumnDefs() {
      const that = this;
      this.excelColumnDefs = [
        {headerName:'요청일자', field:'requestDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'출고센터 상세', field:'outRequestAsAgentNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'출고기사', field:'outRequestUserNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'요청센터', field:'requestAsAgentNm', width:110},
        {headerName:'요청자', field:'requestUserNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'요청구분', field:'requestType', cellStyle:{textAlign: 'center'}, width:110},
        {headerName:'요청품번', field:'itemCd', width:150, cellClass: 'stringType'},
        {headerName:'요청품명', field:'itemNm', width:150, cellClass: 'stringType'},
        {headerName:'요청규격', field:'itemSpec', width:150, cellClass: 'stringType'},
        {headerName:'요청수량', field:'goodQty', width:110, cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
            return that.getNumberFormat(params.value);
          }},
        {headerName:'현재고', field:'currentInventory', width:100, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            if (this.invtGoodQtyReList[params.node.rowIndex] != null) {
              return this.invtGoodQtyReList[params.node.rowIndex]
            }
            else {
              return params.data.outDt === null ? params.data.invtGoodQty : ''
            }
          }
        },
        {headerName:'출고품번', field:'realItemCd', width:170, cellClass: 'stringType'},
        {headerName:'출고품명', field:'realItemNm', width:180, cellClass: 'stringType'},
        {headerName:'출고규격', field:'realItemSpec', width:110, cellClass: 'stringType'},
        {headerName:'출고수량', field:'inGoodQty', width:110},
        {headerName:'출고일자', field:'outDt', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'메모', field:'memo', width:150, cellStyle:{textAlign: 'left'}, cellClass: 'stringType'},
      ];
    },
    mainGridRefresh(idx) {
      var rows = [];
      var rowNode = this.mainGridApi.getDisplayedRowAtIndex(idx);
      rows.push(rowNode);
      this.mainGridApi.redrawRows({ rowNodes: rows });
    },
    // cellEditingQty(params) {
      // const field = params.colDef.field;
      // if(field === 'inGoodQty') {
      //   if(params.data.inGoodQty > 0) {
      //     params.node.setDataValue('chk', 'Y');
      //   } else {
      //     this.data[params.node.rowIndex].inGoodQty = '0';
      //     params.node.setDataValue('chk', 'N');
      //   }
      // }
      //this.createMainColumnDefs();
    // },
    async getRefData(params) {
      let result = this.$http.get(`/api/codeMng/combo`, { params: {parentId: params.data.outCatId} });
      return result;
    },
    async getUserNmData(params) {
      let result = [];
      let resultValue = [{key: '', value: '전체'}];
      let values = [];

      await this.$http.post("/api/asAgentMng/detail/agent", {
        companyId: this.$store.state.loginInfo.compCd,
        asAgentId: parseInt(params.data.outAsAgentId),
        userId : 0,
        useYn : 'Y',
        processTime: ""
      }).then(response => {
        result = response.data.map(x => {
          x.key = x.userId
          x.value = x.userNm
          return x;
        })
      }).finally(() => {
        if (result) {
          _.forEach(result, node => {
            resultValue.push({key: node.key, value: node.value})
          })
          values.push(resultValue);
        }
      });
      return values[0];
    },
    async getGoodQty(params) {
      let values = 0;

      await this.$http.post("/api/workMng/reqMateEnter/userGoodQty", {
        companyId: this.$store.state.loginInfo.compCd,
        asAgentId: parseInt(params.data.outAsAgentId),
        itemId   : params.data.itemId
      }).then(response => {
        values = response.data || 0;
      }).finally();

      return values;
    },
    onCellValueChanged(params) {
      const colId = params.column.getId();
      const idx = params.rowIndex;
      const field = params.colDef.field;
      if(field === 'outCatId') {
        this.getRefData(params)
            .then(result => {
              this.outAsAgentSubNmList = result.data;
              this.createMainColumnDefs();
            })
            .finally(()=> {
              this.mainGridRefresh(idx);
            })
      }
      if (field === 'outAsAgentId') {
        let value;
        this.getUserNmData(params)
            .then(async (result) => {
              this.outUserNmList = result;

              await this.getGoodQty({ data: {outAsAgentId: params.data.outAsAgentId, itemId: params.data.realItemId } })
                  .then(qty => {
                    this.invtGoodQtyReList[idx] = qty || 0;
                    this.createMainColumnDefs();
                  })
            })
            .finally(()=> {
              this.mainGridRefresh(idx);
            })
      }
      if(field === 'outUserId') {
        let value
        this.getGoodQty(params)
            .then(result => {
              value = result == null || result == 'undefined' ? 0 : result;
              this.invtGoodQtyReList[idx] = value;
              this.createMainColumnDefs();
            })
            .finally(() => {
              this.mainGridRefresh(idx);
            })
      }

      if(field === 'inGoodQty') {
        if(parseInt(params.data.inGoodQty) > 0) {
          params.data.chk = 'Y';
        } else {
          params.data.chk = 'N';
        }
        this.mainGridRefresh(idx);
      }
    },
    getCombo(param) {
      if(param.flag === 'INIT'){
        // 접수유형 : AsClass 2레벨
        this.$http.post(`/api/workMng/reqMateEnter/init`)
            .then(response => {
              this.outAsAgentNmList = _.cloneDeep(response.data.catId
                  .map(y => {
                    y.key = y.key;
                    y.value = y.value;
                    return {key: y.key, value: y.value};
                  })
              ) || [];

              this.outAsAgentNmList.unshift({key:'', value:'선택'})
              this.createMainColumnDefs();
            });
      }
    },
    goOpen() {
      let that = this
      this.columnDefs = [];
      this.$store.commit('loading')
      this.$http.post(_url("/api/workMng/reqMateEnter/list"), this.form)
          .then(async (response) => {
            this.invtGoodQtyReList = [];
            this.data = response.data;
            /* data customize */
            _.forEach(this.data, node => {
              this.invtGoodQtyReList.push(node.invtGoodQty);
            })
            await this.changeData();
          })
          .finally(() => {
            this.btnSaveChk();
            this.$store.commit('finish')
          });
    },
    save() {
      var list = this.data.filter(v => v.chk === 'Y')
      this.result = [];
      let matchValue = "N";
      if(list.length > 0){
        this.$swal({
          type: 'question',
          text: '선택한 항목을 출고 저장 하시겠습니까?',
          showCancelButton: true
        }).then(r => {
          if (r.value) {
            this.$store.commit('loading')
            this.result = list;
            if (this.result) {
              _.forEach(this.result, node => {
                if (node.inGoodQty <= 0 || node.currentInventory < node.inGoodQty ) {
                  matchValue = "Y";
                }
              })
            }
            if (matchValue === "Y") {
              this.$store.commit('finish')
              return this.$swal({ type: 'info', text: '출고수량은 0보다 크고 현재고보다 적어야합니다.' });
            }
            else {
              this.$http.post(_url(`/api/workMng/reqMateEnter/save`), this.result)
                  .then((response) => {
                    this.$swal({ type: 'success', text: '출고저장을 하였습니다.' })
                        .then((result) => {
                          if (result.value) {
                            this.goOpen();
                          }
                        });
                  })
                  .catch((e) => {
                    this.$swal({ type: 'success', text: '출고저장에 실패했습니다.' })
                  })
                  .finally(() => {
                    this.$store.commit('finish')
                  });
            }
          }
        })
      } else {
        this.$swal({ type: 'info', text: '저장할 항목을 선택하세요.' });
      }
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/reqMateEnter/init`)
          .then(response => {
            this.combos['requestType'] = response.data.requestType; //요청구분
            this.combos['catId'] = response.data.catId;
            this.combos['maker'] = response.data.maker;
            this.combos['itemGroup'] = response.data.itemGroup;
            this.combos['outType'] = response.data.outType;
          }).finally(() => {
            this.goOpen();
            this.$store.commit('finish');
          });
      this.createMainColumnDefs();
      this.createExcelColumnDefs();
    },
    btnSaveChk(){
      if(this.form.outYn === 'N'){
        this.btnSaveVisible = true;
      } else if (this.form.outYn === 'Y'){
        this.btnSaveVisible = false;
      } else if (this.form.outYn === ''){
        this.btnSaveVisible = false;
      }
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '') this.changeCatIdShow =  false
      else{
        this.changeCatIdShow =  true
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
            .then(response => {
              this.combos['subCatId'] = response.data || []
            });
      }
    },
    onModelGroupChange(param){
      // 제품군
      this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
          .then(response => {
            let subData = response.data.filter(x => x.catKey === param);
            this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                .then(response => {
                  this.combos['subModelGroup'] = response.data || [];
                  this.combos['subModelGroup'].unshift({key: '', value:'전체'});
                });
          })
          .finally(() => {
            this.form.subModelGroup = '';
          });
    },
    /* data customize */
    /**
     * * 여기는 조회된 데이터를 기본 데이터를 세팅하기 위한 부분.
     * * 기존 requestType 세팅 중이였음.
     * * 추가부분 : 출고센터 (공통), 출고센터상세 (용인본사), 출고기사 (전체) 기본 세팅
     */
    async changeData(){
      //step1-1. 출고센터 (공통 : 237) 이으로 출고센터상세 조회
      const parmas = {data : {outCatId: 237} };
      await this.getRefData(parmas)
          .then(res => {
            //step2-1. 출고센터상세 리스트 조회 이후 그리드 렌더링 파라미터 options 부분 세팅
            this.outAsAgentSubNmList = res.data;
          })
          .finally(() => {
            //step3-1. 용인본사 출고기사 리스트 조회
            this.getUserNmData({data : {outAsAgentId: 3} })
                .then(result => {
                  //step3-1. 용인본사 출고기사 조회 이후 그리드 렌더링 파라미터 options 부분 세팅
                  this.outUserNmList = result;
                  //commons. grid 컬럼 부분 다시 그려줌
                  this.createMainColumnDefs();
                })
                .finally(()=> {
                  this.$nextTick(async () => {
                    //step last. 데이터 세팅.
                    this.data = this.data.map(x => {
                      //s.기존에 되어져 있던 부분
                      let filterRequestType = this.combos['requestType'].filter(y => y.key == x.requestType);
                      x.requestType = filterRequestType[0]?.value;
                      //e.기존에 되어져 있던 부분

                      //step1-2. 출고센터 (공통 : 237) 부분 세팅
                      x.outCatId = 237;
                      //step2-3. 출고센터 상세 리스트에서 기본 데이터 용인본사로 세팅
                      x.outAsAgentId = 3;
                      //step3-1. 출고기사 전체로 세팅
                      x.outUserId = '';
                      return x;
                    });
                  });
                })
            //this.data. outAsAgentId
          });
    },
    chkNumber(params, flag, excRt){
      var result = '';
      var val = params.value;
      var data = this.data;

      if(flag === 'sub') data = this.subData;

      if(!_.isEmpty(val) || _.isNumber(val)){
        val = val.toString();

        if (excRt === 'excRt') result = this.$numeral(val).format('0,0.00');
        else result = this.$numeral(val).format('0,0');

        data[params.node.id][params.column.colId] = this.$numeral(val).value();
      }

      return result
    },
    updateRealItem(pVal){

      const that = this;
      const rowNode = this.mainGridOptions.api.getRowNode(this.rowId);

      this.$modal.open({
        component: ReqMateEnterModal,
        parent: this,
        width: 700,
        props: {
          searchStr: pVal
        },
        events: {
          close(object) {
            rowNode.setDataValue('realItemCd', object.itemCd);
            rowNode.setDataValue('realItemNm', object.itemNm);
            that.data[that.rowId].realItemCd = object.itemCd;
            that.data[that.rowId].realItemNm = object.itemNm;
            that.data[that.rowId].realItemId = object.itemId;
            that.data[that.rowId].itemId = object.itemId;

            if (that.data[that.rowId].realItemCd) {
              that.getGoodQty({ data: {outAsAgentId: that.data[that.rowId].outAsAgentId, itemId: object.itemId } })
                  .then(result => {
                    that.invtGoodQtyReList[that.rowId] = result || 0;
                    that.createMainColumnDefs();
                  })
                  .finally(()=> {
                    that.mainGridRefresh(that.rowId);
                  })
            }
          }
        }
      });
    },
    excelDown(){
      this.$store.commit('loading')
      this.$http.post(_url("/api/workMng/reqMateEnter/getExcelList"), this.form)
          .then(response => {
            this.excelData = response.data.map(x => {
              x.requestType = this.combos['requestType'].filter(y => y.key === x.requestType)[0]?.value;
              x.requestDt = x.requestDt !==null ? this.$moment(x.requestDt).format('YYYY-MM-DD HH:mm:ss') : ''
              x.outDt = x.outDt !==null ? this.$moment(x.outDt).format('YYYY-MM-DD') : ''
              x.outRequestAsAgentNm = x.outRequestAsAgentNm !== null ? x.outRequestAsAgentNm : '대우루컴즈'
              x.outRequestUserNm = x.outRequestUserNm !== null ? x.outRequestUserNm : '전체'
              return x
            });
            console.log('this.excelData', this.excelData)

          }).finally(() => {
        this.$store.commit('finish');
        var params = {
          fileName : "요청자재출고"
        };
        this.excelGridOptions.api.exportDataAsExcel(params);

      });
    }
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;

  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>